import { Dimensions, PixelRatio, NativeModules, StyleSheet } from 'react-native';
import CommonBridge from './CommonBridge';

const CommonBridgeModule = NativeModules.CommonBridgeModule;

export const DEFAULT_WIDTH_DP_UI = 360;

class DimensionManager {
  constructor(width, height) {
    this.width = width || Dimensions.get('window').width;
    this.height = height || Dimensions.get('window').height;
    this.scale = 1;
  }

  setScaleDp(width, height, scale) {
    this.width = width;
    this.height = height;
    this.scale = scale;
  }

  // 如果不需要在大屏上乘0.66系数  第三个参数传false
  scaleDp(dp, noRound = false, neesCancelPadScale = false) {
    if (CommonBridge.isWxminiprogram() && !CommonBridge.isWeb()) {
      return StyleSheet.scaleValue(dp);
    } else {
      const scaledp =
        CommonBridge.isTablet() || !CommonBridge.isWeb()
          ? (dp * this.width) / DEFAULT_WIDTH_DP_UI
          : (dp * Math.min(this.width, 600)) / DEFAULT_WIDTH_DP_UI;
      if (noRound) {
        return neesCancelPadScale ? scaledp : scaledp * this.scale;
      }
      return neesCancelPadScale
        ? PixelRatio.roundToNearestPixel(scaledp)
        : PixelRatio.roundToNearestPixel(scaledp) * this.scale;
    }
  }

  scaleDpUnlimit(dp, noRound = false, dpConfig = null) {
    const scaledp = (dp * Dimensions.get('window').width) / DEFAULT_WIDTH_DP_UI;
    if (noRound) {
      return scaledp;
    }
    return PixelRatio.roundToNearestPixel(scaledp);
  }

  scaleFontSize(fontSize) {
    if (CommonBridge.isAndroid()) {
      return Math.ceil(this.scaleDp(fontSize)) * Math.min(1, PixelRatio.getFontScale());
    } else {
      return Math.ceil(this.scaleDp(fontSize));
    }
  }

  scaleLineHeight(lineHeight) {
    if (CommonBridge.isIOS()) {
      return this.scaleDp(lineHeight);
    }
    const scaleLineHeight = this.scaleDp(lineHeight, true);
    return Math.ceil(scaleLineHeight + 3);
  }

  scaleStyle(styles, key, unlimit) {
    switch (Object.prototype.toString.call(styles)) {
      case '[object Number]':
        switch (key) {
          case 'fontSize':
            return this.scaleFontSize(styles);
          case 'lineHeight':
            return this.scaleLineHeight(styles);
          default:
            if (styles <= 1 || ['elevation', 'zIndex'].includes(key)) {
              // 特殊keyt不需要转换 如flex、shadowOpacity
              return styles;
            }
            return unlimit ? this.scaleDpUnlimit(styles) : this.scaleDp(styles);
        }
      case '[object Object]':
        if (styles.mi !== undefined && styles.yp !== undefined) {
          const { mi, yp, ...otherStyle } = styles;
          if (typeof mi !== 'object') {
            return this.scaleStyle(
              ((CommonBridgeModule && CommonBridgeModule.AppKey) || process.env.APPCHANNEL) === 'mishop' ? mi : yp,
            );
          }
          return ((CommonBridgeModule && CommonBridgeModule.AppKey) || process.env.APPCHANNEL) === 'mishop'
            ? this.scaleStyle({
                ...mi,
                ...otherStyle,
              })
            : this.scaleStyle({
                ...yp,
                ...otherStyle,
              });
        }
        if (styles.__scale === false) {
          return styles.__value;
        }
        if (styles.__pad_scale === false) {
          return this.scaleDp(styles.__value, false, true);
        }
        return Object.keys(styles).reduce((prevObj, currKey) => {
          return {
            ...prevObj,
            [currKey]: this.scaleStyle(styles[currKey], currKey, unlimit),
          };
        }, {});
      default:
        return styles;
    }
  }

  /**
   * 支持属性值关闭自己的缩放
   * ScaleStyle({
   *    wrapper: {
   *        width: 100,
   *        height: noScale(100)
   *    }
   * })
   */
  noScale(value) {
    return {
      __scale: false,
      __value: value,
    };
  }

  noPadScale(value) {
    return {
      __pad_scale: false,
      __value: value,
    };
  }
}

export default DimensionManager;
